import emojiList from '@/assets/fonts/emoji.json';
import EmojiIcon from '../../images/emoji.svg?react';
import classes from './index.module.scss';

export interface EmojiProps {
  onEmojiClick?: (emoji: string) => void;
}

export default function Emoji({ onEmojiClick }: EmojiProps) {
  const [openEmoji, setOpenEmoji] = useState(false);

  const emojiGroups = useMemo(() => {
    const groups: Record<string, typeof emojiList> = {};
    emojiList.forEach((item) => {
      if (!groups[item.group]) {
        groups[item.group] = [];
      }
      groups[item.group].push(item);
    });
    return Object.entries(groups);
  }, []);

  return (
    <Popover
      placement="top"
      open={openEmoji}
      onOpenChange={setOpenEmoji}
      content={
        <Tabs
          rootClassName={classes.emojiListTabs}
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          items={emojiGroups.map(([group, items]) => ({
            key: group,
            label: items[0].char,
            children: (
              <ul className={classes.emojiList}>
                {items.map((item) => {
                  return (
                    <li
                      key={item.codes}
                      onClick={() => {
                        setOpenEmoji(false);
                        onEmojiClick?.(item.char);
                      }}
                    >
                      {item.char}
                    </li>
                  );
                })}
              </ul>
            ),
          }))}
        ></Tabs>
      }
    >
      <div>
        <EmojiIcon
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      </div>
    </Popover>
  );
}
